__turbopack_context__.v({
  "buttonContainer": "YearlyReportsTab-module-scss-module__cRTklq__buttonContainer",
  "container": "YearlyReportsTab-module-scss-module__cRTklq__container",
  "desktopList": "YearlyReportsTab-module-scss-module__cRTklq__desktopList",
  "header": "YearlyReportsTab-module-scss-module__cRTklq__header",
  "mobileList": "YearlyReportsTab-module-scss-module__cRTklq__mobileList",
  "noTaxUnitsLink": "YearlyReportsTab-module-scss-module__cRTklq__noTaxUnitsLink",
  "noTaxUnitsText": "YearlyReportsTab-module-scss-module__cRTklq__noTaxUnitsText",
});
